module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAWBAMAAADtIdsqAAAAKlBMVEUAAABoaGhoaGhoaGhwcHBpaWloaGhoaGhnZ2doaGhnZ2dnZ2dmZmZoaGj3FjqUAAAADXRSTlMAgGAgEM/foK/AkLBwFD523QAAAF1JREFUCNdjgAAlKM1+VwHCqIUyPO5eBNMssXcFwAxXqAAzTMAMJpB79wBU4BJUAGoG590bDFARoB64KXBzYVbfYoDZXQBhMN694QBhyd4NgQndZoAK3YQymBYzAACGcCDkHUP7mAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/workOrderReview/back.png
// module id = YJJ0
// module chunks = 0